var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('div', {
    staticClass: "tit-wrap"
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "auto",
      "data-aos": "fade-right",
      "data-aos-delay": "100"
    }
  }, [_c('h3', {
    staticClass: "tit tit--bar"
  }, [_vm._v("진행중인 프로그램")])]), _c('v-spacer'), _c('v-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "auto",
      "data-aos": "fade-left",
      "data-aos-delay": "100"
    }
  }, [_c('v-row', {
    staticClass: "ma-n4"
  }, [_c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "slide-prev",
    attrs: {
      "icon": "",
      "tile": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "left"
    }
  })], 1)], 1), _c('v-col', {
    staticClass: "pa-4",
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    staticClass: "slide-next",
    attrs: {
      "icon": "",
      "tile": "",
      "outlined": "",
      "color": "grey"
    }
  }, [_c('icon-arrow-rounded', {
    staticClass: "icon--size-small",
    attrs: {
      "direction": "right"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1), _c('div', {
    staticClass: "program-slide"
  }, [_c('div', {
    staticClass: "swiper-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l(_vm.applications, function (application) {
    return _c('div', {
      key: application === null || application === void 0 ? void 0 : application._id,
      staticClass: "swiper-slide"
    }, [_c('image-board', {
      staticStyle: {
        "background-color": "transparent"
      },
      attrs: {
        "tile": "",
        "flat": ""
      },
      on: {
        "click": function click($event) {
          return _vm.move(application);
        }
      },
      scopedSlots: _vm._u([{
        key: "image",
        fn: function fn() {
          return [_c('v-responsive', {
            staticClass: "image-card grey lighten-5",
            style: 'background-image: url(' + (application === null || application === void 0 ? void 0 : application.thumb.src) + ');',
            attrs: {
              "width": "100%",
              "aspect-ratio": 282 / 370
            }
          }, [_c('v-overlay', {
            staticClass: "pt-10px pl-10px justify-start align-start",
            attrs: {
              "absolute": "",
              "opacity": "0"
            }
          }, [_c('v-chip', {
            staticClass: "w-md-100px",
            attrs: {
              "large": "",
              "color": "white"
            }
          }, [_c('span', {
            staticClass: "font-weight-medium secondary--text"
          }, [_vm._v(_vm._s(application === null || application === void 0 ? void 0 : application.status))])])], 1)], 1)];
        },
        proxy: true
      }, {
        key: "subject",
        fn: function fn() {
          return [_vm._v(" " + _vm._s(application === null || application === void 0 ? void 0 : application.subject) + " ")];
        },
        proxy: true
      }], null, true)
    }, [[_c('v-row', {
      staticClass: "row--xs"
    }, [_vm._l(application === null || application === void 0 ? void 0 : application.items, function (item, index) {
      return [item.title == '모집 기간' ? _c('v-col', {
        key: index,
        attrs: {
          "cols": "12"
        }
      }, [_c('div', {
        staticClass: "font-size-16 grey--text text--lighten-1",
        domProps: {
          "innerHTML": _vm._s(item.txt.replace(/\n/g, '<br/>'))
        }
      })]) : _vm._e()];
    })], 2)]], 2)], 1);
  }), 0)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }